<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content' > <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-tree-list
        ref="refDivision"
        :height='gridHeight'
        :data-source="divisionList"
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="부서코드"
        parent-id-expr="상위부서코드"
        :focused-row-enabled="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @init-new-row="onInitNewRow"
        @row-inserted='onRowInserted'
        @row-updated='onRowUpdated'
        @row-removed='onRowRemoved'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxEditing
          :allow-adding="(userInfo.permission & crudAllow) > 0"
          :allow-updating="(userInfo.permission & crudAllow) > 0"
          :allow-deleting="(userInfo.permission & crudAllow) > 0"
          :use-icons="true"
          mode="row"
        />
        <dx-column
          data-field="부서코드"
          :allowEditing='true'
          caption="회사/부서코드"
          :allow-sorting="true"
        />
        <dx-column
          data-field="부서명"
          caption="부서명"
          :allow-sorting="true"
          sort-order="asc"
        />
        <dx-column
          data-field="사용유무"
          caption="사용유무"
          :allow-sorting="false"
        />
        <DxColumn
          caption="등록일"
          :allowEditing='false'
          data-field="createdTime"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
        <dx-column
          data-field="createdId"
          :allowEditing='false'
          caption="등록ID"
          :allow-sorting="false"
        />
        <DxColumn
          caption="수정일"
          :allowEditing='false'
          data-field="updatedTime"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
         <dx-column
          data-field="updatedId"
          :allowEditing='false'
          caption="수정ID"
          :allow-sorting="false"
        />

        <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <DxPaging :enabled="false"/>
      </dx-tree-list>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import { DxTreeList, DxColumn, DxSearchPanel, DxScrolling, DxPaging, DxEditing } from 'devextreme-vue/tree-list'

export default {
  name: 'login',
  data: function () {
    return {
      crudAllow: ConstDef.SYSTEM_ADMIN,
      userInfo: this.$store.getters.getUserInfo,
      isLoading: false,
      selectedIndex: 0,
      divisionList: null,
      gridHeight: null
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxColumn,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
    DxEditing
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.refreshDivisionList()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onInitNewRow (e) {
      console.log(e)
      // if (e.data.상위부서코드 === '0' || e.data.상위부서코드 === 0) {
      //   e.data.상위부서코드 = 'null'
      // }
      e.data.사용유무 = true
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatedId = row.data.createdId = this.userInfo.userId
      if (row.data.상위부서코드 === '0' || row.data.상위부서코드 === 0) {
        row.data.상위부서코드 = null
      }
      this.$_sp.runInsertSqlProc('부서정보', null, [row.data])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {
      console.log(row)
      let child = this.$_.findWhere(this.divisionList, { 상위부서코드: row.data.부서코드 })
      if (child !== undefined) {
        this.onRowRemoved({ data: child })
      }
      this.$_sp.runDeleteSqlProc('부서정보', [{ 부서코드: row.data.부서코드 }])
        .then((data) => {
          let index = this.$_.findIndex(this.divisionList, { 부서코드: row.data.부서코드 })
          if (index >= 0) {
            this.divisionList.splice(index, 1)
          }
        })
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatedId = this.userInfo.userId
      let array = []
      array.push(this.$_appLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('부서정보', ['부서코드'], ['seqId'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    refreshDivisionList () {
      this.isLoading = true

      this.$_sp.runFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_.sortBy(this.$_sp.MakeModel(data), '부서코드')
          this.gridHeight = (screen.height - 250) * 0.95
          console.log(this.divisionList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.ff{
  text-align: center;
}
</style>
